export enum QuestionPageViewEnum {
  EDIT = 'EDIT',
  HISTORY = 'HISTORY',
  STATISTICS = 'STATISTICS',
}
